import client from "~/v2/api/client"
import type { ClientSummary } from "~/v2/types/vaas"

const listClients = (): Promise<ClientSummary[]> =>
  client.get("/clients").then((response: any) => response.data?.data || [])

export { listClients }
